class CardTip {

    /**
     * @since 0.5.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.selector = '[data-card-tip]';
        this.flood;

        // Run initialization
        this.init();
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 0.5.0
     * @returns object The initialized map
     */
    init() {
        // If there are no cardTips, bail
        if (!$(this.selector).length) return;

        // Listen for the smooth scroll activator
        $(this.selector).each((i, item) => {

            // Listen for that mousemovement
            $(item).on('mousemove', (e) => {

                // If the flood gate is opened, close it
                if (this.flood)
                    clearTimeout(this.flood);

                // Set a flood gate
                this.flood = setTimeout(
                    () => this.tip($(e.currentTarget), e),
                    0
                );

            });

            // Reset the tilt
            $(item).on('mouseleave', function (e) {

                // Declare and initialize
                let ele = $(this).find('[data-card-tip-element]');

                // Remove the init class
                ele.removeClass('card-tip-init');

                // Back to normal
                ele.css({
                    transition: 'transform .25s ease-in-out',
                    transform:  'rotateX(0deg) rotateY(0deg)'
                });

            });

        });

        // Prevent leaks
        return;
    }

    /**
     * Run the calculations for card tipping.
     *
     * @since 0.5.0
     * @method tip
     * @param object target is the context target
     * @param object event is the triggered event
     * @return void
     */
    tip(target, event) {
        // Declare and initialize
        var strength    = target.data('card-top-strength') || 16;
        var perspective = target.data('card-top-perspective') || '2000px';
        let ele         = target.find('[data-card-tip-element]') || ele;
        let parent      = ele.parent();
        let offsetX     = (parent.outerWidth() - parent.width()) / 2;
        let offsetY     = (parent.outerHeight() - parent.height()) / 2;
        let dim         = {w: ele.width(), h: ele.height()};
        let isInit      = ele.hasClass('card-tip-init');
        let pos         = {
            x: Math.round(event.pageX - parent.offset().left - offsetX),
            y: Math.round(event.pageY - parent.offset().top - offsetY)
        };

        // Map out the percentages
        let ratio = {
            y: (Math.round((pos.x / dim.w) * strength) - (strength / 2)) + 'deg',
            x: -1 * (Math.round((pos.y / dim.h) * strength) - (strength / 2)) + 'deg'
        };

        // Set the correct perspective
        target.css({perspective: perspective});

        // Undo transition
        ele.css({transition: 'none'});

        // Make it wiggly
        ele.css({
            transform: 'rotateX(' + ratio.x + ') rotateY(' + ratio.y + ')'
        });

        // Add in the init class
        ele.addClass('card-tip-init');
    }

}

export default CardTip;